<template>
    <section class="discounts">
        <div class="discounts__bg">
            <div class="row">
                <div class="columns small-12">
                    <h2 class="discounts__header discounts__header--red">JAK DZIAŁA PROGRAM LOKALE BLISKICH KREWNYCH?</h2>
                    <p>
                        Lokale Bliskich Krewnych oferują w swoim menu zniżki stałe i czasowe.  
                    </p>
                </div>
            </div>
            <div class="row discounts__row">
                <div class="columns small-12 large-9">
                    <h3 class="discounts__header discounts__header--blue">Zniżki stałe</h3>
                    <p>
                       Zniżki stałe to niewielkie zniżki przysługujące każdemu krwiodawcy.
                       Można z nich skorzystać pokazując ważną legitymację krwiodawcy
                       lub aktywny status krwiodawcy w swojej aplikacji.   
                    </p>
                </div>
                <div class="columns small-12 large-3">
                    <img src="/img/view-1.png" class="discounts__image" alt="Widok z aplikacji mobilnej" />
                </div>
            </div>
        </div>
        <div v-if="0 === 1" class="row">
            <div class="columns small-12 large-8">
                <h3 class="discounts__header discounts__header--blue">Zniżki czasowe (KUPONY)</h3>
                <p>
                    Zniżki powyżej 49%, dostępne w ciągu 60 dni od oddania krwi – każdorazowo po oddaniu krwi, w aplikacji generowany jest kupon promocyjny.
                    Krwiodawca może wybrać jeden (i tylko jeden) z oferowanych kuponów i wykorzystać go w Lokalu oferującym zniżkę. 
                </p>
                <p>
                    Kupony mogą być wykorzystywane tylko przy użyciu aktywnej aplikacji.  
                </p>
            </div>
        </div>
        <div v-if="0 === 1" class="row discounts__expanded">
            <div class="columns small-12 large-4">
                <div class="discounts__step">
                    <img src="/img/view-2.png" alt="Widok aplikacji mobilnej" />
                    <p>
                        Krwiodawca nie może wykorzystać żadnego kuponu, ponieważ w ciągu ostatnich 60 dni nie oddał krwi  
                    </p>
                </div>
            </div>
            <div class="columns small-12 large-4">
                <div class="discounts__step">
                    <img src="/img/view-3.png" alt="Widok aplikacji mobilnej" />
                    <p>
                         Krwiodawca może wykorzystać kupon w Lokalu oferującym zniżkę.
                    </p>
                </div>
            </div>
            <div class="columns small-12 large-4">
                <div class="discounts__step">
                    <img src="/img/view-4.png" alt="Widok aplikacji mobilnej" />
                    <p>
                        Po aktywacji kuponu, Krwiodawca ma 15 minut na wykorzystanie zniżki i okazanie kuponu sprzedawcy.  
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  name: 'Discounts',
});
</script>

<style lang='scss' scoped>
.discounts {
    margin: 30px 0;

    &__bg {
        background-color: #FFF5F5;
        padding: 40px 0;
        margin-bottom: 40px;
    }

    &__header {
        
        &--red {
            color: $primary-red;
            text-transform: uppercase;
            margin: 25px 0;
        }

        &--blue {
            color: #384477;
            margin-bottom: 35px;
        }
    }

    &__row {
        display: flex;
        align-items: center;
    }
    
    &__image {
        margin: 0 auto;
        display: block;
    }

    &__expanded {
        margin-top: 60px;
        max-width: 85rem;
    }

    &__step {
        img {
            margin: 0 auto;
            display: block;
        }
        p{
            margin: 30px 0;
            text-align: center;
            font-weight: 400;
        }
    }
}
</style>